import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonNotificationsService } from '@client/ng2/core/services/notifications/mon-notifications.service';
import { NotificationRepoService } from '@client/app/services/api/notification-repo/notification-repo.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationsRunService {
    private lastUpdate: string | null = null;
    private updateParams: any = {
        page_size: 100,
        filter: 'new',
    };

    constructor (
        private monEventService: MonEventService,
        private monNotificationsService: MonNotificationsService,
        private notificationRepoService: NotificationRepoService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    initializeApp (): void {
        Object.defineProperty(this.updateParams, 'updated_after', {
            enumerable: true,
            get: () => {
                return this.lastUpdate ? encodeURIComponent(this.lastUpdate) : this.lastUpdate;
            },
        });

        this.monNotificationsService.notifications.subscribe((notifications) => {
            if (!notifications || notifications.length === 0) {
                return;
            }
            const latest = notifications[0];

            if (latest) {
                this.lastUpdate = String(latest.done_at || latest.updated_at || latest.created_at);
            }
        });

        this.monEventService.addListener('setAccount', () => {
            if (this.activeFeatureService.isFeatureActive('notifications')) {
                this.monEventService.addListener('finishCustomer', () => {
                    const params = { ...this.updateParams };
                    if (params.lastUpdate == null) {
                        delete params.lastUpdate;
                    }
                    if (params.updated_after == null) {
                        delete params.updated_after;
                    }
                    this.monNotificationsService.init(((p: Record<string, unknown>) => this.notificationRepoService.getAll(p as any)) as (params: Record<string, unknown>) => Promise<unknown>, params);
                });
                this.monEventService.addListener('exitCustomer', () => {
                    this.monNotificationsService.cancelPromise();
                });

                this.monEventService.addListener('logout', () => {
                    this.monNotificationsService.destroy();
                });
            }
        });

    }
}
